import { useForm } from "react-hook-form";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { zodResolver } from "@hookform/resolvers/zod";
import { PesquisaSatisfacaoItemForm, PesquisaSatisfacaoItemSchema } from "../../../schemas/CadastroPesquisaItens_cadastro/pesquisa_satisfacao_item";
import { useEffect } from "react";
import { PesquisaSatisfacaoItemLista } from "../../../../domain/models/pesquisa_satisfacao_item_lista";

import DefaultFormInput from "../../../../../../common/components/default_form_input";

/**
 * PesquisaSatisfacaoItemModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  selectedPesquisaSatisfacaoItem: PesquisaSatisfacaoItemLista | null;
  onClose: () => void;
  onSubmit: (form: PesquisaSatisfacaoItemForm) => void;
};

export const PesquisaSatisfacaoItemModal = ({
  open,
  saving,
  loading,
  selectedPesquisaSatisfacaoItem,
  onClose,
  onSubmit,
}: Props) => {

  const hookForm = useForm<PesquisaSatisfacaoItemForm>({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
    resolver: zodResolver(PesquisaSatisfacaoItemSchema),
  });

  useEffect(() => {
    if (open) {
      if (selectedPesquisaSatisfacaoItem) {
        hookForm.setValue('ordem', selectedPesquisaSatisfacaoItem.ordem ?? '');
        hookForm.setValue('descricao', selectedPesquisaSatisfacaoItem.descricao ?? '');
      } else {
        hookForm.reset();
      }
    }
  }, [
    open,
    selectedPesquisaSatisfacaoItem,
    hookForm,
  ]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      title="Item Pesquisa de Satisfação"
      onClose={onClose}
      onSubmit={hookForm.handleSubmit(onSubmit)}>
      <div className="w-full flex flex-col gap-2 my-2">
        <DefaultFormInput
          name='ordem'
          label='Ordem'
          required={true}
          reactHookForm={hookForm}
        />

        <DefaultFormInput
          name='descricao'
          label='Descrição do Item'
          required={true}
          reactHookForm={hookForm}
        />
      </div>
    </BaseFormControlledModal>
  );
}